import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { ownerApi, inr, errText } from "@/lib/ownerApi";

export default function Settlement() {
  const [d, setD] = useState(null);
  useEffect(() => { ownerApi.get("/salary/settlement").then(({ data }) => setD(data)).catch((e) => toast.error(errText(e))); }, []);
  if (!d) return <Loader2 className="h-6 w-6 animate-spin text-emerald-800 mx-auto" />;
  const sum = (k) => d.teachers.reduce((s, t) => s + t[k], 0);
  return (
    <div className="space-y-3" data-testid="owner-settlement">
      <p className="text-sm text-stone-600">Full year {d.ay} (June – April, 11 months). Each teacher's entitlement is recalculated with today's live Fees Due. Balance = what is still to pay (+) or was overpaid (−).</p>
      <div className="overflow-x-auto rounded-xl border border-stone-200 bg-white">
        <table className="min-w-full text-sm" data-testid="owner-settlement-table">
          <thead className="bg-stone-100 text-stone-600"><tr>{["Teacher", "Full-year entitlement", "Extra − Deductions", "Final due", "Paid so far", "Balance"].map((h) => <th key={h} className="px-3 py-2 text-left font-semibold whitespace-nowrap">{h}</th>)}</tr></thead>
          <tbody className="divide-y divide-stone-100">
            {d.teachers.map((t) => (
              <tr key={t.key} data-testid={`owner-settlement-${t.key}`}>
                <td className="px-3 py-2 font-semibold">{t.name}</td><td className="px-3 py-2">{inr(t.entitlement)}</td><td className="px-3 py-2">{inr(t.adjustments)}</td>
                <td className="px-3 py-2">{inr(t.final_due)}</td><td className="px-3 py-2 text-emerald-800">{inr(t.paid)}</td>
                <td className={`px-3 py-2 font-bold ${t.balance < 0 ? "text-red-700" : "text-amber-800"}`}>{t.balance < 0 ? `Overpaid ${inr(-t.balance)}` : `Pay ${inr(t.balance)}`}</td>
              </tr>
            ))}
            <tr className="bg-stone-50 font-bold"><td className="px-3 py-2">Total</td><td className="px-3 py-2">{inr(sum("entitlement"))}</td><td className="px-3 py-2">{inr(sum("adjustments"))}</td><td className="px-3 py-2">{inr(sum("final_due"))}</td><td className="px-3 py-2">{inr(sum("paid"))}</td><td className="px-3 py-2" data-testid="owner-settlement-total">{inr(sum("balance"))}</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
